 
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
 
// import Button from 'react-bootstrap/Button';
import { useMediaQuery } from 'react-responsive';
import logo from "../Components/images/logo.png";
import star from "../Components/images/star.png";
import car from "../Components/images/car2.png";
import magnet from "../Components/images/magnet.png";
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import CustomCursor from '../Components/CustomCursor';

import logo1 from "../Components/images/logo1.jpeg";
import logo2 from "../Components/images/logo2.avif";
import logo3 from "../Components/images/logo3.avif";
import logo4 from "../Components/images/logo4.avif";
import logo5 from "../Components/images/logo5.avif";
import logo6 from "../Components/images/logo6.avif";
import logo7 from "../Components/images/logo7.avif";
import logo8 from "../Components/images/logo8.avif";
import logo9 from "../Components/images/logo9.avif";
import logo10 from "../Components/images/logo10.avif"; 
import logo11 from "../Components/images/logo1.webp"; 
import logo12 from "../Components/images/logo12.png"; 
import logo13 from "../Components/images/logo13.png"; 
import logo15 from "../Components/images/logo15.png"; 
import blr1 from "../Components/images/blr1.png"; 








import { useLocation } from 'react-router-dom';
import HomeCompoOne from '../Components/HomeCompoOne';
import HomeCompoTwo from '../Components/HomeCompoTwo';

export default function Home() {

 const [position, setPosition] = useState({ x: 0, y: 0 });

  const location = useLocation();
const isMobile = useMediaQuery({ maxWidth: 768 });
  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Delay for render
      }
    }
  }, [location]);


  useEffect(() => {
    const moveCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', moveCursor);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
    };
  }, []);



  const elements = document.querySelectorAll('.text-blur');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
    }
  });
});

elements.forEach(el => observer.observe(el));



  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-black text-white min-vh-100"

      
    >

       <CustomCursor />
      <div
        className="d-flex flex-column"
        style={{
          maxWidth: "1200px",
          width: "90%",
          margin: "100px auto 0 auto",
        }}
      >
        {/* Main Content */}
        {/* <div className="client-section d-flex flex-column align-items-center justify-content-center text-center mt-2">
          <div className="d-flex align-items-center gap-3 mb-2">
            
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <img
                src={client1}
                alt="client"
                className="rounded-circle"
                width="30"
                height="30"
              />
              <img
                src={client2}
                alt="client"
                className="rounded-circle"
                width="30"
                height="30"
              />
              <img
                src={client5}
                alt="client"
                className="rounded-circle"
                width="30"
                height="30"
              />
              <img
                src={imga1}
                alt="client"
                className="rounded-circle bg-white"
                width="30"
                height="30"
              />
              <img
                src={client5}
                alt="client"
                className="rounded-circle"
                width="30"
                height="30"
              />
            </div>

           
            <div className="text-start">
              <div>
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fas fa-star text-white icsz"></i>
                ))}
                
              </div>
              <p className=" mt-0 mb-0 text-mutednew">
                130+ profitable clients
              </p>
            </div>
          </div>
        </div> */}

        <div className="home">

         {/* <h1 className="display-3 fw-bold anton ft1">
  <span className="fade-in blur-delay delay-1">Test Our </span>
  
  <span className="fade-in blur-delay delay-2 text-warning2">&nbsp;GOOGLE ADS</span>
  <br />
  <span className="fade-in blur-delay delay-3 text-warning2">GROWTH ACCELERATOR</span>
  <br />
  <span className="fade-in blur-delay delay-4">For Yourself.</span>
</h1> */}


<h1 className="hero-heading ft1">
  <span className="hero-line delay-1">Test Our</span>
 
  <span className="hero-line delay-2 text-warning2">&nbsp;GOOGLE ADS</span>
  <br />
  <span className="hero-line delay-3 text-warning2">GROWTH ACCELERATOR</span>
  <br />
  <span className="hero-line delay-4">For Yourself.</span>
</h1>

{!isMobile && (
          <p className="mt-4 text-secondary fs-5 text-blur  hero-heading">
            <span className='mt-4 text-secondary fs-5 hero-line delay-4'>
              Unlock rapid, scalable growth for your Shopify D2C or <br />
            dropshipping brand with our performance-driven Google Ads
            strategies.
            <br />
            We specialize exclusively in helping ambitious eCommerce brands grow
            — <br />
            and we back it up with our unmatched ROAS Guarantee.
            </span>
            
          </p>
          )}
{isMobile && (
          <p className="mt-4 text-secondary fs-5  hero-heading">
            <span className=' mt-4 text-secondary fs-5 hero-line delay-4'>
              Unlock rapid, scalable growth for your Shopify D2C or <br />
            dropshipping brand with our performance-driven Google Ads
            strategies.
            <br />
            We specialize exclusively in helping ambitious eCommerce brands grow
            — <br />
            and we back it up with our unmatched ROAS Guarantee.
            </span>
          </p>
)}

          <Link to="/contact" className="btn btn-purple  mt-4 px-3 py-2">
            Book Your Free Strategic Session! 
          </Link>

          <div>
            {/* <div className="framer1"></div> */}

            <Link to="/contact" className="blurred-glow-bg">
  <Link to="/contact" className="cta-button">Book Your Free Strategic Session! ⚡</Link>
</Link>



{/* <div className="image-wrapper">
  <img src={blr1} className="img-fluid blended-image" alt="..." />
</div>
 */}


          </div>
        </div>

        {/* Partners Section */}
        <div className="partners-section text-center pt-1 mt-1">
          <p className="mt-4 text-secondary fs-5">
            A Robust Network for Maximum Growth — We collaborate closely with
            industry-leading partners
          </p>
 
        </div>

        <div className="logo-slider">
          <div className="slider-track">
            <img
              src={logo11}
              alt="Shopify"
            />
            <img
              src={logo2}
              alt="Ecomflows"
            />
            <img
              src={logo3}
              alt="Partner 1"
            />
            <img
              src={logo4}
              alt="Service Points"
            />
            <img
              src={logo5}
              alt="Elysian Exit"
            />

            <img
              src={logo6}
              alt="Shopify"
            />
            <img
              src={logo7}
              alt="Ecomflows"
            />
            <img
              src={logo8}
              alt="Partner 1"
            />
            <img
              src={logo9}
              alt="Service Points"
            />
            <img
              src={logo10}
              alt="Elysian Exit"
            />

            <img
              src={logo12}
              alt="Elysian Exit"
            />
            <img
              src={logo13}
              alt="Elysian Exit"
            />

            <img
              src={logo11}
              alt="Shopify"
            />
            <img
              src={logo2}
              alt="Ecomflows"
            />
            <img
              src={logo3}
              alt="Partner 1"
            />
            <img
              src={logo4}
              alt="Service Points"
            />
            <img
              src={logo5}
              alt="Elysian Exit"
            />

            <img
              src={logo6}
              alt="Shopify"
            />
            <img
              src={logo7}
              alt="Ecomflows"
            />
            <img
              src={logo8}
              alt="Partner 1"
            />
            <img
              src={logo9}
              alt="Service Points"
            />
            <img
              src={logo10}
              alt="Elysian Exit"
            />

            <img
              src={logo12}
              alt="Elysian Exit"
            />
            <img
              src={logo13}
              alt="Elysian Exit"
            />

            <img
              src={logo11}
              alt="Shopify"
            />
            <img
              src={logo2}
              alt="Ecomflows"
            />
            <img
              src={logo3}
              alt="Partner 1"
            />
            <img
              src={logo4}
              alt="Service Points"
            />
            <img
              src={logo5}
              alt="Elysian Exit"
            />

            <img
              src={logo6}
              alt="Shopify"
            />
            <img
              src={logo7}
              alt="Ecomflows"
            />
            <img
              src={logo8}
              alt="Partner 1"
            />
            <img
              src={logo9}
              alt="Service Points"
            />
            <img
              src={logo10}
              alt="Elysian Exit"
            />

            <img
              src={logo12}
              alt="Elysian Exit"
            />
            <img
              src={logo13}
              alt="Elysian Exit"
            />

            <img
              src={logo11}
              alt="Shopify"
            />
            <img
              src={logo2}
              alt="Ecomflows"
            />
            <img
              src={logo3}
              alt="Partner 1"
            />
            <img
              src={logo4}
              alt="Service Points"
            />
            <img
              src={logo5}
              alt="Elysian Exit"
            />

            <img
              src={logo6}
              alt="Shopify"
            />
            <img
              src={logo7}
              alt="Ecomflows"
            />
            <img
              src={logo8}
              alt="Partner 1"
            />
            <img
              src={logo9}
              alt="Service Points"
            />
            <img
              src={logo10}
              alt="Elysian Exit"
            />

            <img
              src={logo12}
              alt="Elysian Exit"
            />
            <img
              src={logo13}
              alt="Elysian Exit"
            />
          </div>
        </div>

        {/* <button className="btn btn-outline-light mt-4 px-4 py-2">Comparison</button> */}
        {/* 
      </div> */}

        {/* Comparison Heading */}
        <div className="text-center " style={{marginTop: '80px'}}>
          <div className="text-center">
            {" "}
            <span className="comp1 mt-4 px-4 py-2 text-white">Comparison</span>
          </div>

          <h2 className="display-3 fw-bold anton ft1 mt-4">
            Why would you want to
            <br /> work <span className="text-warning2">WITH US?</span>
          </h2>

          <div className="container py-3">
            <div className="row justify-content-center">
              <div className="col-md-5">
                <h2 className="fw-bold text-warning mb-5  mt-5  ">
                  <img
                    src={logo15}
                    alt="Logo" className='me-2'
                    style={{ height: "42px", objectFit: "cover" }}
                  />
                  <span className='ftfl0'>Dropshopi</span>
                </h2>

                <div className="card-storm custom-card text-white border-0 rounded-4 shadow p-4">
                  <ul className="list-unstyled text-start">
                    <li >
                      
                      <div className='d-flex'>
                        <div><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256" className='me-4'
    style={{
      userSelect: "none",
       
      height: "100%",maxHeight: '20px',
      display: "inline-block",
      fill: "rgb(194 150 6)",
      flexShrink: 0,
    }}
  >
    <g color="rgb(194 150 6)">
      <path d="M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z" />
    </g>
  </svg></div>
                        <div>Proven roadmap - GUARANTEED Success</div>
                      </div>
                      
                      </li>


                    <li>
                      
                       <div className='d-flex'>
                        <div><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256" className='me-4'
    style={{
      userSelect: "none",
      
      height: "100%",maxHeight: '20px',
      display: "inline-block",
      fill: "rgb(194 150 6)",
      flexShrink: 0,
    }}
  >
    <g color="rgb(194 150 6)">
      <path d="M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z" />
    </g>
  </svg></div>
                        <div>Hyper-specialized in Shopify E-commerce</div>
                      </div>
                      </li>
                    <li>
                      
                       <div className='d-flex'>
                        <div><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256" className='me-4'
    style={{
      userSelect: "none",
      
      height: "100%",maxHeight: '20px',
      display: "inline-block",
      fill: "rgb(194 150 6)",
      flexShrink: 0,
    }}
  >
    <g color="rgb(194 150 6)">
      <path d="M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z" />
    </g>
  </svg></div>
                        <div> Performance Based Fees</div>
                      </div>
                      
                     </li>
                    <li>
                      
                       <div className='d-flex'>
                        <div><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256" className='me-4'
    style={{
      userSelect: "none",
      
      height: "100%", maxHeight: '20px',
      display: "inline-block",
      fill: "rgb(194 150 6)",
      flexShrink: 0,
    }}
  >
    <g color="rgb(194 150 6)">
      <path d="M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z" />
    </g>
  </svg></div>
                        <div>Own AI Driven Software - Smart Decisions</div>
                      </div>
                      
                      </li>
                    <li>
                      
                       <div className='d-flex'>
                        <div><svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256" className='me-4'
    style={{
      userSelect: "none",
     
      height: "100%",maxHeight: '20px',
      display: "inline-block",
      fill: "rgb(194 150 6)",
      flexShrink: 0,
    }}
  >
    <g color="rgb(194 150 6)">
      <path d="M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z" />
    </g>
  </svg></div>
                        <div>24/7 Monitoring - Proactive Support</div>
                      </div>
                      
                      </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-5 mb-4">
                <div>
                  <h2 className="fw-bold text-secondary1 nwsz1 mb-5 mt-5  text-center">
                    Other Agencies
                  </h2>

                  <div className="feature-box custom-card negative-box p-4 rounded-4 text-light">
                    <ul className="list-unstyled mb-0 text-start">
                      <li className="mb-3">

                        <div className='d-flex'>
                          <div> <i className="bi bi-x-lg me-2 text-secondary"></i></div>
                          <div>Generic —
                        No proven system, hit or miss</div>
                        </div>
                        
                      </li>
                      <li className="mb-3">
                        <div className='d-flex'>
                          <div><i className="bi bi-x-lg me-2 text-secondary"></i></div>
                          <div>Lack of
                        Shopify-specific expertise</div>
                        </div>
                         
                      </li>
                      <li className="mb-3">
                        <div className='d-flex'>
                          <div><i className="bi bi-x-lg me-2 text-secondary"></i></div>
                          <div>Fixed
                        fees — you pay regardless of results</div>
                        </div>
                         
                      </li>
                      <li className="mb-3">
                        <div className='d-flex'>
                          <div><i className="bi bi-x-lg me-2 text-secondary"></i></div>
                          <div> Third-party tools — no control or innovation</div>
                        </div>
                      
                      </li>
                      <li className="mb-3">
                        <div className='d-flex'>
                          <div><i className="bi bi-x-lg me-2 text-secondary"></i></div>
                          <div>Reactive
                        support — slow response</div>
                        </div>
                         
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* results */}

       <HomeCompoOne/>

        {/* Process */}

        <div className="container-process text-center min-vh-100 d-flex flex-column justify-content-center align-items-center px-3 py-5" 
        id="proccess">
          <div className="text-center">
            {" "}
            <span className="comp1 mt-4 px-4 py-2 text-white">Process</span>
          </div>

          <h1
            className="display-3 fw-bold anton ft3 mt-4"
            style={{ maxWidth: "800px" }}
          >
            Our Proven 3-Step Process to
            <span className="text-warning"> Skyrocket </span> Your Brand
          </h1>

          <p
            className="mt-3 text-secondary fs-5 "
            style={{ maxWidth: "750px" }}
          >
            We don’t just run ads — we build momentum. Our proprietary strategy
            and <br />
            AI-powered software take you from setup to market domination in
            three powerful phases. From zero to unstoppable — we’ve got your
            growth covered.
          </p>

          {/* Cards Row */}

          <div className="bg-black py-5">
            <div className="container">
              <div className="row text-white text-center justify-content-center">
                {/* Card 1 */}
                <div className="col-md-4 px-4 mb-4">
                  <img src={star} alt="star img" className="step-img mb-3" />
                  <h5 className="fw-bold">UNLEASH</h5>
                  <p className="text-secondary">
                    Audit. Launch. Ignite. <br />
                    We start with deep performance audits, Google Ads strategy,
                    and laser-targeted campaigns to unleash your brand’s full
                    potential from day one.
                  </p>
                </div>

                {/* Card 2 */}
                <div className="col-md-4 px-4 mb-4">
                  <div >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 430 430"
                      width="430"
                      height="430" className="svgcls step-img"
                      preserveAspectRatio="xMidYMid slice"
                       
                    >
                      <defs>
                        <clipPath id="__lottie_element_51">
                          <rect width="430" height="430" x="0" y="0"></rect>
                        </clipPath>
                        <clipPath id="__lottie_element_54">
                          <path d="M0,0 L430,0 L430,430 L0,430z"></path>
                        </clipPath>
                        <filter
                          id="__lottie_element_60"
                          filterUnits="objectBoundingBox"
                          x="0%"
                          y="0%"
                          width="100%"
                          height="100%"
                        >
                          <feComponentTransfer in="SourceGraphic">
                            <feFuncA
                              type="table"
                              tableValues="1.0 0.0"
                            ></feFuncA>
                          </feComponentTransfer>
                        </filter>
                        <mask id="__lottie_element_57" mask-type="alpha">
                          <g filter="url(#__lottie_element_60)">
                            <rect
                              width="430"
                              height="430"
                              x="0"
                              y="0"
                              fill="#ffffff"
                              opacity="0"
                            ></rect>
                            <g
                              transform="matrix(0.9999949932098389,0.0031593649182468653,-0.0031593649182468653,0.9999949932098389,203.1042938232422,214.98934936523438)"
                              opacity="1"
                              style={{display: 'block'}}
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  fill="rgb(255,199,56)"
                                  fill-opacity="1"
                                  d=" M9.887700080871582,-44.320762634277344 C11.583854675292969,-45.73375701904297 12.93387508392334,-45.08880615234375 12.900466918945312,-42.8814582824707 C12.900466918945312,-42.8814582824707 12.404533386230469,-10.114542007446289 12.404533386230469,-10.114542007446289 C12.371125221252441,-7.9071946144104 14.13640022277832,-6.114999771118164 16.3439998626709,-6.114999771118164 C16.3439998626709,-6.114999771118164 51.54800033569336,-6.114999771118164 51.54800033569336,-6.114999771118164 C53.75559997558594,-6.114999771118164 54.13027572631836,-5.0183000564575195 52.38414001464844,-3.667555332183838 C52.38414001464844,-3.667555332183838 -9.797139167785645,44.433555603027344 -9.797139167785645,44.433555603027344 C-11.54327392578125,45.7843017578125 -12.930862426757812,45.0888557434082 -12.893743515014648,42.88156509399414 C-12.893743515014648,42.88156509399414 -12.411256790161133,14.190434455871582 -12.411256790161133,14.190434455871582 C-12.374137878417969,11.983146667480469 -14.13640022277832,10.190999984741211 -16.3439998626709,10.190999984741211 C-16.3439998626709,10.190999984741211 -51.54800033569336,10.190999984741211 -51.54800033569336,10.190999984741211 C-53.75559997558594,10.190999984741211 -54.17085266113281,9.043756484985352 -52.474700927734375,7.63076114654541 C-52.474700927734375,7.63076114654541 9.887700080871582,-44.320762634277344 9.887700080871582,-44.320762634277344z"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </mask>
                      </defs>
                      <g clip-path="url(#__lottie_element_51)">
                        <g
                          clip-path="url(#__lottie_element_54)"
                          transform="matrix(1,0,0,1,0,0)"
                          opacity="1"
                           style={{display: 'block'}}
                        >
                          <g
                            transform="matrix(0.9999949932098389,0.0031593649182468653,-0.0031593649182468653,0.9999949932098389,-14.231155395507812,4.301666259765625)"
                            opacity="1"
                            style={{display: 'block'}}
                          >
                            <g
                              opacity="1"
                              transform="matrix(1,0,0,1,217.5,210)"
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="secondary"
                                  fill="rgb(255,255,255)"
                                  fill-opacity="1"
                                  d=" M44.49800109863281,-87.78800201416016 C44.49800109863281,-87.78800201416016 117.5,0 117.5,0 C117.5,0 147.5,0 147.5,0 C169.59100341796875,0 187.5,17.909000396728516 187.5,40 C187.5,40 187.5,95 187.5,95 C187.5,95 -187.5,95 -187.5,95 C-187.5,95 -187.5,20 -187.5,20 C-187.5,8.954000473022461 -178.54600524902344,0 -167.5,0 C-167.5,0 -162.5,0 -162.5,0 C-162.5,0 -132.3209991455078,-81.91400146484375 -132.3209991455078,-81.91400146484375 C-129.4239959716797,-89.7770004272461 -121.93299865722656,-95 -113.55400085449219,-95 C-113.55400085449219,-95 29.1200008392334,-95 29.1200008392334,-95 C35.0629997253418,-95 40.698001861572266,-92.35700225830078 44.49800109863281,-87.78800201416016z"
                                ></path>
                              </g>
                            </g>
                            <g
                              opacity="0.5"
                              transform="matrix(1,0,0,1,217.5,210.0019989013672)"
                               
                               style={{mixBlendMode: 'multiply'}}
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="secondary"
                                  fill="rgb(255,255,255)"
                                  fill-opacity="1"
                                  d=" M-167.5,-0.0020000000949949026 C-178.54600524902344,-0.0020000000949949026 -187.5,8.95199966430664 -187.5,19.99799919128418 C-187.5,19.99799919128418 -187.5,95.00199890136719 -187.5,95.00199890136719 C-187.5,95.00199890136719 187.5,95.00199890136719 187.5,95.00199890136719 C187.5,95.00199890136719 187.5,70.0479965209961 187.5,70.0479965209961 C187.5,70.0479965209961 -159.5,70.0479965209961 -159.5,70.0479965209961 C-161.15699768066406,70.0479965209961 -162.5,68.70500183105469 -162.5,67.0479965209961 C-162.5,67.0479965209961 -162.5,19.99799919128418 -162.5,19.99799919128418 C-162.5,8.95199966430664 -153.54600524902344,-0.0020000000949949026 -142.5,-0.0020000000949949026 C-142.5,-0.0020000000949949026 -139.5919952392578,-0.0020000000949949026 -139.5919952392578,-0.0020000000949949026 C-138.3350067138672,-0.0020000000949949026 -137.21200561523438,-0.7850000262260437 -136.77699279785156,-1.9639999866485596 C-136.77699279785156,-1.9639999866485596 -107.32099914550781,-81.91600036621094 -107.32099914550781,-81.91600036621094 C-104.42400360107422,-89.77899932861328 -96.93299865722656,-95.00199890136719 -88.55400085449219,-95.00199890136719 C-88.55400085449219,-95.00199890136719 -113.55400085449219,-95.00199890136719 -113.55400085449219,-95.00199890136719 C-121.93299865722656,-95.00199890136719 -129.4239959716797,-89.77899932861328 -132.3209991455078,-81.91600036621094 C-132.3209991455078,-81.91600036621094 -162.5,-0.0020000000949949026 -162.5,-0.0020000000949949026 C-162.5,-0.0020000000949949026 -167.5,-0.0020000000949949026 -167.5,-0.0020000000949949026z"
                                ></path>
                              </g>
                            </g>
                          </g>
                          <g
                            transform="matrix(-0.9426430463790894,0.3338025212287903,-0.3338025212287903,-0.9426430463790894,708.6968994140625,485.6893310546875)"
                            opacity="1"
                             style={{display: 'block'}}
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,320,305)">
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="primary"
                                  fill="rgb(255,182,0)"
                                  fill-opacity="1"
                                  d=" M0,40 C22.090999603271484,40 40,22.090999603271484 40,0 C40,-22.090999603271484 22.090999603271484,-40 0,-40 C-22.090999603271484,-40 -40,-22.090999603271484 -40,0 C-40,22.090999603271484 -22.090999603271484,40 0,40z"
                                ></path>
                              </g>
                            </g>
                            <g
                              opacity="0.5"
                              transform="matrix(1,0,0,1,314.54998779296875,306.27801513671875)"
                            
                               style={{mixBlendMode: 'multiply'}}
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="primary"
                                  fill="rgb(255,182,0)"
                                  fill-opacity="1"
                                  d=" M20.450000762939453,28.722000122070312 C25.413000106811523,28.722000122070312 30.165000915527344,27.81800079345703 34.54999923706055,26.166000366210938 C27.256999969482422,33.89699935913086 16.91699981689453,38.72200012207031 5.449999809265137,38.72200012207031 C-16.641000747680664,38.72200012207031 -34.54999923706055,20.812999725341797 -34.54999923706055,-1.277999997138977 C-34.54999923706055,-18.4060001373291 -23.78499984741211,-33.02000045776367 -8.651000022888184,-38.72200012207031 C-15.407999992370605,-31.55900001525879 -19.549999237060547,-21.902000427246094 -19.549999237060547,-11.277999877929688 C-19.549999237060547,10.812999725341797 -1.6410000324249268,28.722000122070312 20.450000762939453,28.722000122070312z"
                                ></path>
                              </g>
                            </g>
                          </g>
                          <g
                            transform="matrix(-0.9426430463790894,0.3338025212287903,-0.3338025212287903,-0.9426430463790894,300.74188232421875,555.787841796875)"
                            opacity="1"
                            style={{display: 'block'}}
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,110,305)">
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="primary"
                                  fill="rgb(255,182,0)"
                                  fill-opacity="1"
                                  d=" M0,-40 C22.076000213623047,-40 40,-22.076000213623047 40,0 C40,22.076000213623047 22.076000213623047,40 0,40 C-22.076000213623047,40 -40,22.076000213623047 -40,0 C-40,-22.076000213623047 -22.076000213623047,-40 0,-40z"
                                ></path>
                              </g>
                            </g>
                            <g
                              opacity="0.5"
                              transform="matrix(1,0,0,1,104.55000305175781,306.27801513671875)"
                              style={{mixBlendMode: 'multiply'}}
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="primary"
                                  fill="rgb(255,182,0)"
                                  fill-opacity="1"
                                  d=" M20.450000762939453,28.722000122070312 C25.413000106811523,28.722000122070312 30.165000915527344,27.81800079345703 34.54999923706055,26.166000366210938 C27.256999969482422,33.89699935913086 16.91699981689453,38.72200012207031 5.449999809265137,38.72200012207031 C-16.641000747680664,38.72200012207031 -34.54999923706055,20.812999725341797 -34.54999923706055,-1.277999997138977 C-34.54999923706055,-18.4060001373291 -23.78499984741211,-33.02000045776367 -8.651000022888184,-38.72200012207031 C-15.407999992370605,-31.55900001525879 -19.549999237060547,-21.902000427246094 -19.549999237060547,-11.277999877929688 C-19.549999237060547,10.812999725341797 -1.6410000324249268,28.722000122070312 20.450000762939453,28.722000122070312z"
                                ></path>
                              </g>
                            </g>
                          </g>
                          <g
                            transform="matrix(1,0,0,1,215,215)"
                            opacity="1"
                            style={{display: 'block'}}
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                fill-opacity="0"
                                className="primary"
                                stroke="rgb(255,182,0)"
                                stroke-opacity="1"
                                stroke-width="7"
                                d=" M122.93099975585938,130.5 C70.84100341796875,130.5 -2.6419999599456787,130.5 -64.76100158691406,130.5"
                              ></path>
                            </g>
                          </g>
                          <g
                           style={{display: 'none'}}
                            transform="matrix(1,0,0,1,215,215)"
                            opacity="1"
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                fill-opacity="0"
                                className="primary"
                                stroke="rgb(255,182,0)"
                                stroke-opacity="1"
                                stroke-width="7"
                                d="M0 0"
                              ></path>
                            </g>
                          </g>
                          <g
                            style={{display: 'none'}}
                            transform="matrix(1,0,0,1,215,215)"
                            opacity="1"
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                fill-opacity="0"
                                className="primary"
                                stroke="rgb(255,182,0)"
                                stroke-opacity="1"
                                stroke-width="7"
                                d=" M-177.42799377441406,130.5 C-182.3249969482422,130.5 -185,130.5 -185,130.5"
                              ></path>
                            </g>
                          </g>
                          <g
                            transform="matrix(0.9999949932098389,0.0031593649182468653,-0.0031593649182468653,0.9999949932098389,188.10435485839844,214.9419708251953)"
                            opacity="1"
                            style={{display: 'block'}}
                          >
                            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                              <path
                                className="tertiary"
                                fill="rgb(255,182,0)"
                                fill-opacity="1"
                                d=" M9.887700080871582,-44.320762634277344 C11.583854675292969,-45.73375701904297 12.93387508392334,-45.08880615234375 12.900466918945312,-42.8814582824707 C12.900466918945312,-42.8814582824707 12.404533386230469,-10.114542007446289 12.404533386230469,-10.114542007446289 C12.371125221252441,-7.9071946144104 14.13640022277832,-6.114999771118164 16.3439998626709,-6.114999771118164 C16.3439998626709,-6.114999771118164 51.54800033569336,-6.114999771118164 51.54800033569336,-6.114999771118164 C53.75559997558594,-6.114999771118164 54.13027572631836,-5.0183000564575195 52.38414001464844,-3.667555332183838 C52.38414001464844,-3.667555332183838 -9.797139167785645,44.433555603027344 -9.797139167785645,44.433555603027344 C-11.54327392578125,45.7843017578125 -12.930862426757812,45.0888557434082 -12.893743515014648,42.88156509399414 C-12.893743515014648,42.88156509399414 -12.411256790161133,14.190434455871582 -12.411256790161133,14.190434455871582 C-12.374137878417969,11.983146667480469 -14.13640022277832,10.190999984741211 -16.3439998626709,10.190999984741211 C-16.3439998626709,10.190999984741211 -51.54800033569336,10.190999984741211 -51.54800033569336,10.190999984741211 C-53.75559997558594,10.190999984741211 -54.17085266113281,9.043756484985352 -52.474700927734375,7.63076114654541 C-52.474700927734375,7.63076114654541 9.887700080871582,-44.320762634277344 9.887700080871582,-44.320762634277344z"
                              ></path>
                            </g>
                          </g>
                          <g
                            mask="url(#__lottie_element_57)"
                   
                            style={{display: 'block', mixBlendMode: 'multiply'}}
                          >
                            <g
                              transform="matrix(0.9999949932098389,0.0031593649182468653,-0.0031593649182468653,0.9999949932098389,188.10435485839844,214.9419708251953)"
                              opacity="0.5"
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  className="tertiary"
                                  fill="rgb(255,182,0)"
                                  fill-opacity="1"
                                  d=" M9.887700080871582,-44.320762634277344 C11.583854675292969,-45.73375701904297 12.93387508392334,-45.08880615234375 12.900466918945312,-42.8814582824707 C12.900466918945312,-42.8814582824707 12.404533386230469,-10.114542007446289 12.404533386230469,-10.114542007446289 C12.371125221252441,-7.9071946144104 14.13640022277832,-6.114999771118164 16.3439998626709,-6.114999771118164 C16.3439998626709,-6.114999771118164 51.54800033569336,-6.114999771118164 51.54800033569336,-6.114999771118164 C53.75559997558594,-6.114999771118164 54.13027572631836,-5.0183000564575195 52.38414001464844,-3.667555332183838 C52.38414001464844,-3.667555332183838 -9.797139167785645,44.433555603027344 -9.797139167785645,44.433555603027344 C-11.54327392578125,45.7843017578125 -12.930862426757812,45.0888557434082 -12.893743515014648,42.88156509399414 C-12.893743515014648,42.88156509399414 -12.411256790161133,14.190434455871582 -12.411256790161133,14.190434455871582 C-12.374137878417969,11.983146667480469 -14.13640022277832,10.190999984741211 -16.3439998626709,10.190999984741211 C-16.3439998626709,10.190999984741211 -51.54800033569336,10.190999984741211 -51.54800033569336,10.190999984741211 C-53.75559997558594,10.190999984741211 -54.17085266113281,9.043756484985352 -52.474700927734375,7.63076114654541 C-52.474700927734375,7.63076114654541 9.887700080871582,-44.320762634277344 9.887700080871582,-44.320762634277344z"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  {/* <img src={car} alt="car img" className="step-img mb-3" /> */}
                  <h5 className="fw-bold">SCALE</h5>
                  <p className="text-secondary">
                    Optimize. Automate. Grow. <br />
                    With human-led expertise and smart AI, we refine your
                    campaigns, boost performance, and scale profitably without
                    guesswork.
                  </p>
                </div>

                {/* Card 3 */}
                <div className="col-md-4 px-4 mb-4">
                  <img
                    src={magnet}
                    alt="magnet img"
                    className="step-img mb-3"
                  />
                  <h5 className="fw-bold">DOMINATE</h5>
                  <p className="text-secondary">
                    Expand. Lead. Own the Market. <br />
                    We build full-funnel systems, increase customer lifetime
                    value, and position your brand as the category leader — not
                    just a competitor.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* content */}

          <div className="process-content text-center p-2">


            <h1 className="display-3 fw-bold anton ft2  ">Your Strategic Growth Partner  
              <br/>
              <span class="text-warning2">Powered by Data, Driven by Results</span><br/>
               
              We don’t just run ads, we build businesses.</h1>

 

            <Link to="/contact" className="btn btn-purple mt-4 px-4 py-2">
              Ready to Scale with Google Ads <span>&#9889;</span>
            </Link>
          </div>
        </div>

        {/* Team */}

        {/* <div
          className="container-result d-flex flex-column justify-content-center align-items-center text-center px-3"
          style={{
            marginTop: "0px",
            paddingTop: "0px",
            paddingBottom: "20px",
          }}
        >
         
          <h2
            className="display-3 fw-bold anton ft2"
            style={{ maxWidth: "800px" }}
          >
            See the  <span className="text-warning"> Shopify  </span> Results.
          </h2>

          <p className="mt-3 text-secondary fs-5" style={{ maxWidth: "750px" }}>
            From scrappy startups to scaling powerhouses,
            <br />
            we’ve driven real results for brands that demand more.
            <br />
            Across industries, our performance speaks louder than words — and
            the numbers back it up.
          </p>
        </div> */}

        <HomeCompoTwo/>

<div id="faqAccordion" className='mb-5'></div>
<div  className='mb-5 d-none d-lg-block'></div>



<div className='text-center'  >
  <h2
            className="display-3 fw-bold anton ft3 mt-2"
             
          >Frequently Asked 
           <span className="text-warning"> Questions</span>  
          </h2>
</div>
        



        <div
          className="accordion faq-accordion responsive-accordion"
          
        >
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Which platforms do you manage?
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse "
              aria-labelledby="headingOne"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
              We start with Google Ads and accelerate the performance using the Meta
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
              Are there any hidden charges?
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                No, we don't have any hidden charges, we only charge 8.5% of your ad spend
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
              Do you have fixed monthly charges?
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
              We only charge 8.5% of your ad spend or 3.5% of your platform revenue, you can choose any model
              </div>
            </div>
          </div>


          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
              Do you provide performance reports?
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
               Yes, we provide weekly performance report and CRO suggestions
              </div>
            </div>
          </div>


          <div className="accordion-item">
            <h2 className="accordion-header" id="headingfive">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsefive"
                aria-expanded="false"
                aria-controls="collapsefive"
              >
             Do you offer services for startups
              </button>
            </h2>
            <div
              id="collapsefive"
              className="accordion-collapse collapse"
              aria-labelledby="headingfive"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
              Yes, We do and also share winning products
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSix">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
              Do You also fix the Merchant account suspension?
              </button>
            </h2>
            <div
              id="collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="headingSix"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
             Yes, We help with this most challenging painpoint of dropshipping business owners, we charge $300 to fix the merchant suspension
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSeven">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
             Do you have fixed contract terms?
              </button>
            </h2>
            <div
              id="collapseSeven"
              className="accordion-collapse collapse"
              aria-labelledby="headingSeven"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
            No, we don't have fixed contracts. However, to achieve meaningful growth and optimize your campaigns effectively, we recommend a minimum commitment of 3 months.
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}



         <div className="bg-black text-white py-1" style={{marginBottom: '50px'}}>
                    <Container className="d-flex justify-content-center align-items-center ">
                        <div className="box-container">
                            <div className="strategy-card text-center px-4 py-5">
                                <h1 className="display-3 fw-bold anton ft1   ">
                                    Ready to Experience Game-Changing Growth?<br />
                                    Put Our  <span className="text-warning2  ">NEXT LEVEL STRATEGY </span>to the Test
                                </h1>

                                <p className="text-secondary mt-4 fs-5 fw-medium">
                                    <span className="text-warning"><span>&#9889;</span> Limited Spots Available - </span> We only work with entrepreneurs who<br /> are
                                    ready to <strong>scale and maximise ROAS</strong>. Don’t miss this<br /> opportunity – book your session today!
                                </p>

                                <Link to="/contact" variant="primary" className="btn-purple  ">
                                    Book Your Free Strategic Call  

                                </Link>
                            </div>
                        </div>
                    </Container>
                </div>


      </div>
    </motion.div>
  );
}
